import { CONFIG_COGNITO_SHOPIFY_MULTIPASS_TOKEN_ENDPOINT } from '@src/config/env'
import { getUserSession } from '../utils'
import customerAccessTokenCreateWithMultipass from './customerAccessTokenCreateWithMultipass'

const multipassTokenFetchURL = CONFIG_COGNITO_SHOPIFY_MULTIPASS_TOKEN_ENDPOINT

const fetchCustomerAccessToken = async client => {
  const userSession = await getUserSession()
  if (!userSession?.idToken?.jwtToken) return null
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Authorization', userSession.idToken.jwtToken)

  const multipassFetch = await fetch(multipassTokenFetchURL, {
    method: 'GET',
    headers,
  })
  const multipassToken = await multipassFetch.json()

  const accessTokenResult = await customerAccessTokenCreateWithMultipass(client, {
    multipassToken,
  })

  const {
    data: {
      customerAccessTokenCreateWithMultipass: { customerAccessToken },
    },
  } = accessTokenResult

  return customerAccessToken
}

export default fetchCustomerAccessToken
